import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'redux-first-router-link';
import { LocaleString } from '@biw/intl';
// scss
import './cancel-button.scss';

export default class CancelButton extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        children: PropTypes.array
    };

    goBack = ( event ) => {
        event.preventDefault();
        window.history.back();
    };

    render() {
        const { className, children } = this.props;
        return (
            <div className="cancel-button-container">
                <Link aria-label="Cancel" to="/" className={ classNames( 'btn-cancel', 'client-link', className ) }>
                    { children || <LocaleString code="forgotPassword.form.cancel" /> }
                </Link>
            </div>
        );
    }
}
